import {
    COI_THI,
    HANDLE_CHEAT,
    MARK_GENERAL,
    MARK_SPEAKING, MARK_TRIAL,
    PENDING, SUCCESS,
    MARK_ENTRANCE_SPEAKING, MARK_ENTRANCE_GENERAL
} from "@/view/pages/marking-exam/model/taskPersonal";

const PILOT_EMPLOYEE_CODES = [367448,3068099,2988263,2982707,2982705,2988999,2940802,405381,3031851,2921102,2982699,2941803,2988083,2983446,3042828,3049808];


const CHO_PHAT_HANH = 0
const DA_PHAT_HANH = 1
const DUNG_PHAT_HANH = 2
const CHO_XU_LY_HUY = 3
const HUY_HOA_DON = 4
const THAT_BAI = 5
const CHUYEN_KHOAN = 1
const QUET_THE = 2
const CONG_NO = 3
const IMPORT = 4
const CITIME = 5

const statusManagementKpi = [
    {
        name: 'Cần nhập thành phẩm',
        value: 0,
    },
    {
        name: 'Cần chấm',
        value: 1,
    },
    {
        name: 'Đã chấm',
        value: 2,
    },
]

const pointOptionKpi = [
    {
        name: '0%',
        value: 0,
    },
    {
        name: '30%',
        value: 30,
    },
    {
        name: '60%',
        value: 60,
    },
    {
        name: '90%',
        value: 90,
    },
    {
        name: '100%',
        value: 100,
    },
]

const stageOption = [
    {
        name: 'Đang tích lũy',
        value: 0,
    },
    {
        name: 'Có hiệu lực',
        value: 1,
    },
    {
        name: 'Được chuyển nhượng/Bán',
        value: 2,
    },
    {
        name: 'Đã chuyển nhượng/Bán',
        value: 3,
    },
]

const resultPointWeekly = [
    {
        name: 'Không đạt',
        value: 0,
    },
    {
        name: 'Đạt',
        value: 1,
    },
]

const statusProduction = [
    {
        name: 'Chờ lớp',
        value: 1,
    },
    {
        name: 'Đang học khóa dưới',
        value: 2,
    },
    {
        name: 'Đang xử lý đầu ra',
        value: 3,
    },
]

const category_chamsoc_define = {
    1: 'Nghỉ học 2 buổi',
    2: 'Điểm kiểm tra thấp',
    3: 'Không làm bài',
    4: 'Chua đóng tiền học',
    5: 'Đã đóng tiền học',
    6: 'Feedback thấp',
    7: 'Nghỉ học 1 buổi',
    8: 'Vắng có phép',
    9: 'Hướng dẫn app cho phụ huynh',
    10: 'Kết quả BTVN không tốt',
    11: 'Không làm BTVN',
    13: 'Nhắc nhở bảo hành',
    14: 'Nghỉ 1 buổi không phép',
    15: 'Nghỉ buổi khai giảng',
    16: 'Chăm sóc học viên giữa khóa'
}

const listReasonAbsent = [
    {
        'id': 1,
        'value': 'Nghỉ hẳn lớp học',
    },
    {
        'id': 2,
        'value': 'Bận việc cá nhân',
    },
    {
        'id': 3,
        'value': 'Vấn đề ve sức khỏe',
    },
    {
        'id': 4,
        'value': 'Quân sự/ thực tập',
    },
    {
        'id': 5,
        'value': 'Khác',
    },
    {
        id: 25,
        value: '2 buổi không làm BTVN',
    },
    {
        id: 26,
        value: 'Nghỉ học 2 buổi',
    },
    {
        id: 27,
        value: 'Nghỉ 1 buổi + Không làm BTVN 1 buổi.',
    },
]

const problems = [
    {
        id: 1,
        name: 'Feedback Giáo viên',
    },
    {
        id: 19,
        name: 'Feedback trợ giảng',
    },
    {
        id: 3,
        name: 'Cơ sở vật chất',
    },
    {
        id: 20,
        name: 'Xin thêm tài liệu',
    }, {
        id: 21,
        name: 'Feedback App BTVN',
    },
    {
        id: 22,
        name: 'Yêu cầu bổ trợ',
    },
    {
        id: 23,
        name: 'Khác',
    },
]
const listReasonOffLesson = [
    {
        id: 9,
        name: 'Bận việc cá nhân',
    },
    {
        id: 10,
        name: 'Trùng lịch học',
    },
    {
        id: 11,
        name: 'Nghỉ ốm',
    },
    {
        id: 12,
        name: 'Du lịch',
    }, {
        id: 13,
        name: 'Quân sự/ Thực tập',
    },
    {
        id: 14,
        name: 'Bảo lưu',
    },
    {
        id: 24,
        name: 'Nghỉ hẳn',
    },
    {
        id: 23,
        name: 'Khác',
    },
]

const statusReportError = [
    {
        id: 1,
        name: 'Chưa xử lý'
    },
    {
        id: 2,
        name: 'Đã xử lý'
    },
    {
        id: 3,
        name: 'Hủy'
    },
]

const statusDefine = {
    0: 'Hủy',
    1: 'Chờ xử lý',
    2: 'Đã nhập giải pháp',
    3: 'Đã hoàn thành'
}

const templateCertificates = [
    {
        id: 1,
        templateName: 'IM-Basic',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 378,
        fontSizeDate: 20,
        topDate: 675,
        leftDate: 130,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IM-basic.png',
        fontStyle: 'normal'
    },
    {
        id: 2,
        templateName: 'IM-Pre',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 380,
        fontSizeDate: 20,
        topDate: 605,
        leftDate: 157,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IM-Pre.png',
        fontStyle: 'normal'
    },
    {
        id: 3,
        templateName: 'IM-3.5-4.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 508,
        fontSizeDate: 20,
        topDate: 700,
        leftDate: 105,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IM-3.5-4.5.png',
        fontStyle: 'normal'
    },
    {
        id: 4,
        templateName: 'IM-4.5-5.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 470,
        fontSizeDate: 20,
        topDate: 705,
        leftDate: 132,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IM-4.5-5.5.png',
        fontStyle: 'normal'
    },
    {
        id: 5,
        templateName: 'IM-5.5-6.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 406,
        fontSizeDate: 20,
        topDate: 720,
        leftDate: 105,
        width: 595,
        height: 842,
        color: 2,
        image: 'certificate-IM-5.5-6.5.png',
        fontStyle: 'normal'
    },
    {
        id: 6,
        templateName: 'IM-Outstanding',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 440,
        fontSizeDate: 20,
        topDate: 675,
        leftDate: 128,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IM-outstanding.png',
        fontStyle: 'normal'
    },
    {
        id: 7,
        templateName: 'IM-Excellent',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 470,
        fontSizeDate: 20,
        topDate: 675,
        leftDate: 138,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IM-Excellent.png',
        fontStyle: 'normal'
    },
    {
        id: 8,
        templateName: 'EC-Basic',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 390,
        fontSizeDate: 20,
        topDate: 660,
        leftDate: 97,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-basic.jpg',
        fontStyle: 'normal'
    },
    {
        id: 9,
        templateName: 'EC-Pre',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 440,
        fontSizeDate: 20,
        topDate: 640,
        leftDate: 110,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-Pre.jpg',
        fontStyle: 'normal'
    },
    {
        id: 10,
        templateName: 'EC-GTCB',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 440,
        fontSizeDate: 20,
        topDate: 640,
        leftDate: 110,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-GTCB.jpg',
        fontStyle: 'normal'
    },
    {
        id: 11,
        templateName: 'EC-4.5-5.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 450,
        fontSizeDate: 20,
        topDate: 638,
        leftDate: 154,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-4.5-5.5.jpg',
        fontStyle: 'normal'
    },
    {
        id: 12,
        templateName: 'EC-5.5-6.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 445,
        fontSizeDate: 20,
        topDate: 654,
        leftDate: 138,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-55-65.jpg',
        fontStyle: 'normal'
    },
    {
        id: 13,
        templateName: 'EC-Outstanding',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 415,
        fontSizeDate: 20,
        topDate: 629,
        leftDate: 130,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-outstanding.jpg',
        fontStyle: 'normal'
    },
    {
        id: 14,
        templateName: 'EC-Excellent',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 400,
        fontSizeDate: 20,
        topDate: 630,
        leftDate: 118,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-Excellent.jpg',
        fontStyle: 'normal'
    },
    {
        id: 15,
        templateName: 'EC-Foundation',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 395,
        fontSizeDate: 20,
        topDate: 685,
        leftDate: 135,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-EC-foundation.jpg',
        fontStyle: 'normal'
    },
    {
        id: 16,
        templateName: 'CU-Basic',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 390,
        fontSizeDate: 20,
        topDate: 665,
        leftDate: 95,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-basic.jpg',
        fontStyle: 'normal'
    },
    {
        id: 17,
        templateName: 'CU-Pre',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 435,
        fontSizeDate: 20,
        topDate: 640,
        leftDate: 107,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-Pre.jpg',
        fontStyle: 'normal'
    },
    {
        id: 18,
        templateName: 'CU-foundation',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 395,
        fontSizeDate: 20,
        topDate: 690,
        leftDate: 140,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-foundation.jpg',
        fontStyle: 'normal'
    },
    {
        id: 19,
        templateName: 'CU-4.5-5.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 455,
        fontSizeDate: 20,
        topDate: 635,
        leftDate: 155,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-4.5-5.5.jpg',
        fontStyle: 'normal'
    },
    {
        id: 20,
        templateName: 'CU-5.5-6.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 450,
        fontSizeDate: 20,
        topDate: 650,
        leftDate: 140,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-5.5-6.5.jpg',
        fontStyle: 'normal'
    },
    {
        id: 21,
        templateName: 'CU-Outstanding',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 420,
        fontSizeDate: 20,
        topDate: 625,
        leftDate: 128,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-outstanding.jpg',
        fontStyle: 'normal'
    },
    {
        id: 22,
        templateName: 'CU-Excellent',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 400,
        fontSizeDate: 20,
        topDate: 625,
        leftDate: 118,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-Excellent.jpg',
        fontStyle: 'normal'
    },
    {
        id: 23,
        templateName: 'IE-7.0',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 440,
        fontSizeDate: 20,
        topDate: 600,
        leftDate: 130,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IE-7.0+.jpg',
        fontStyle: 'normal'
    },
    {
        id: 24,
        templateName: 'IE-7.5',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 400,
        fontSizeDate: 20,
        topDate: 625,
        leftDate: 118,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IE-7.5.jpg',
        fontStyle: 'normal'
    },
    {
        id: 25,
        templateName: 'IE-LD',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 505,
        fontSizeDate: 20,
        topDate: 665,
        leftDate: 118,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-IE-LD.jpg',
        fontStyle: 'normal'
    },
    {
        id: 26,
        templateName: 'CU-LD',
        type: 'portrait',
        fontName: 'SVN-Flamingo-script',
        fontFile: 'SVN-Flamingo-script.ttf',
        fontSizeName: 50,
        topName: 500,
        fontSizeDate: 20,
        topDate: 665,
        leftDate: 118,
        width: 595,
        height: 842,
        color: 1,
        image: 'certificate-CU-LD.jpg',
        fontStyle: 'normal'
    },
]

const statusInvoice = [
    {
        value: CHO_PHAT_HANH,
        name: 'Chờ phát hành'
    },
    {
        value: DA_PHAT_HANH,
        name: 'Đã phát hành'
    },
    {
        value: THAT_BAI,
        name: 'Thất bại'
    },
    {
        value: CHO_XU_LY_HUY,
        name: 'Chờ xử lý hủy'
    },
    {
        value: DUNG_PHAT_HANH,
        name: 'Dừng phát hành'
    },
    {
        value: HUY_HOA_DON,
        name: 'Hủy hóa đơn'
    }
]

const typeInvoice = [
    {
        value: CHUYEN_KHOAN,
        name: 'Chuyển khoản'
    },
    {
        value: QUET_THE,
        name: 'Quẹt thẻ'
    },
    {
        value: CONG_NO,
        name: 'Công nợ'
    },
    {
        value: IMPORT,
        name: 'Import'
    },
    {
        value: CITIME,
        name: 'Citime'
    }
]

const juridicalOption = [
    {
        value: 2,
        name: 'Ecoach'
    },
    {
        value: 1,
        name: 'Ielts Mentor'
    }
]

const typeExams = [
    {
        id: 0,
        name: 'Thi chính',
    },
    {
        id: 1,
        name: 'Thi thử, Thi lại'
    },
    {
        id: 2,
        name: 'Thi đầu khóa'
    },
]

const typeNotMainExam = [
    {
        id: 1,
        name: 'Thi thử, Thi lại'
    },
    {
        id: 2,
        name: 'Thi đầu khóa'
    },
]

const examScheduleTypes = [
    {
        id: 0,
        name: 'Thi chính',
    },
    {
        id: 1,
        name: 'Thi thử',
    },
    {
        id: 3,
        name: 'Thi lại',
    },
    {
        id: 2,
        name: 'Thi đầu khóa',
    }
]

const testForms = [
    {
        id: 1,
        name: 'Online',
    },
    {
        id: 2,
        name: 'Offline'
    },
]

const resultTestOption = [
    {
        id: 0,
        name: 'Fail',
    },
    {
        id: 1,
        name: 'Pass',
    },
]

const paymentMethods = [
    {
        name: 'Quẹt máy Pos',
        id: 1
    },
    {
        name: 'Chuyển khoản công ty',
        id: 2
    },
    {
        name: 'Chuyển khoản cá nhân',
        id: 3
    },
    {
        name: 'Tiền mặt',
        id: 4
    }
]

const numberRetestOption = [
    {
        id: 1,
        name: 'Thi lại lần 1',
    },
    {
        id: 2,
        name: 'Thi lại lần 2',
    },
    {
        id: 3,
        name: 'Thi lại lần 3',
    },
    {
        id: 4,
        name: 'Thi lại lần 4',
    },
    {
        id: 5,
        name: 'Thi lại lần 5',
    },
     {
        id: 6,
        name: 'Thi lại lần 6',
    },
      {
        id: 7,
        name: 'Thi lại lần 7',
    },
       {
        id: 8,
        name: 'Thi lại lần 8',
    },
        {
        id: 9,
        name: 'Thi lại lần 9',
    },
         {
        id: 10,
        name: 'Thi lại lần 10',
    },
]

const taskStatusOption = [
    {
        id: 0,
        name: 'Cần làm',
    },
    {
        id: 1,
        name: 'Hoàn thành',
    },
]

const typeExamOption = [
    {
        id: MARK_SPEAKING,
        name: 'Chấm speaking',
    },
    {
        id: MARK_GENERAL,
        name: 'Chấm general',
    },
    {
        id: COI_THI,
        name: 'Coi thi',
    },
    {
        id: MARK_TRIAL,
        name: 'Chấm thi giữa khoá',
    },
    {
        id: MARK_ENTRANCE_SPEAKING,
        name: 'Chấm thi đầu khóa Speaking',
    },
    {
        id: MARK_ENTRANCE_GENERAL,
        name: 'Chấm thi đầu khóa General',
    }
]

const checkPlagiarismOption = [
    {
        label: 'Từ 30% tới 50%',
        value: 0,
    },
    {
        label: 'Từ 50% trở lên',
        value: 1,
    }
]

const typeTaskOption = [
    {
        id: MARK_SPEAKING,
        name: 'Chấm speaking',
    },
    {
        id: MARK_GENERAL,
        name: 'Chấm general',
    },
    {
        id: MARK_TRIAL,
        name: 'Chấm thi giữa khoá',
    },
    {
        id: MARK_ENTRANCE_SPEAKING,
        name: 'Chấm thi đầu khóa Speaking',
    },
    {
        id: MARK_ENTRANCE_GENERAL,
        name: 'Chấm thi đầu khóa General',
    },
]

const ExamType = [
    {
        value: 1,
        label: 'Cuối khóa',
    },
    {
        value: 0,
        label: 'Giữa khóa',
    },
    {
        value: 2,
        label: 'Thi lại',
    },
    {
        value: 3,
        label: 'Thi đầu khóa',
    },
]

const statusTaskOption = [
    {
        id: PENDING,
        name: 'Cần làm',
    },
    {
        id: SUCCESS,
        name: 'Hoàn thành',
    },
    {
        id: HANDLE_CHEAT,
        name: 'Xử lý gian lận',
    },
]

const quarterOptions = [
    {
        label: 'Quý I',
        value: 1,
    },
    {
        label: 'Quý II',
        value: 2,
    },
    {
        label: 'Quý III',
        value: 3,
    },
    {
        label: 'Quý IV',
        value: 4,
    }
]

const statusOkrOption = [
    {
        label: 'Chưa đánh giá',
        value: 0,
    },
    {
        label: 'Đạt dưới 60% so với KPIs mục tiêu',
        value: 1,
    },
    {
        label: 'Đạt từ 60% so với KPIs mục tiêu',
        value: 2,
    },
    {
        label: 'Đạt từ 70% so với KPIs mục tiêu',
        value: 3,
    },
    {
        label: 'Đạt từ 80% so với KPIs mục tiêu',
        value: 4,
    },
    {
        label: 'Đạt mốc KPI tối thiểu',
        value: 5,
    },
    {
        label: 'Hoàn thành (Đạt KPIs mục tiêu)',
        value: 6,
    }
]

const typeOkrOption = [
    {
        label: 'OKR cấp phòng ban',
        value: 1,
    },
    {
        label: 'OKR cấp công ty',
        value: 2,
    }
]

const statusOptions = [
    {
        label: 'Chưa duyệt',
        value: 0,
    },
    {
        label: 'Đã duyệt',
        value: 1,
    }
]
export const YET_CONFIRM = 'not_confirmed';
export const CONFIRMED = 'confirmed_error'
export const NOT_ERROR = 'no_error'
export const CONFIRMED_NUMBER = 0
export const NOT_ERROR_NUMBER = 1


export const confirmStatusList = [
    {value: YET_CONFIRM,label:'Chưa xác nhận'},
    {value:CONFIRMED,label:'Đã xác nhận lỗi'},
    {value: NOT_ERROR, label:'Không lỗi'}
]
export const confirmList = [
    {value:CONFIRMED_NUMBER,label:'Đã xác nhận lỗi'},
    {value: NOT_ERROR_NUMBER, label:'Không lỗi'}
]

const typeExamTest = [
    {
        label: 'Đề test dành cho khách hàng học Basic - IELTS 6.5',
        value: 0,
    },
    {
        label: 'Đề test dành cho khách hàng học IELTS 6.5+',
        value: 1,
    }
]

export const solutionOptions = [
    {
        label: 'Nhập giải pháp',
        value: 1,
    },
    {
        label: 'Cần thêm thông tin',
        value: 2,
    },
    {
        label: 'Tiếp nhận xử lý',
        value: 3,
    },
    {
        label: 'Đề xuất chuyển tiếp phòng ban',
        value: 4,
    },
]

export {
    problems,
    stageOption,
    pointOptionKpi,
    resultPointWeekly,
    statusManagementKpi,
    statusProduction,
    category_chamsoc_define,
    statusReportError,
    listReasonAbsent,
    listReasonOffLesson,
    statusDefine,
    templateCertificates,
    typeExams,
    examScheduleTypes,
    testForms,
    statusInvoice,
    typeInvoice,
    CHO_PHAT_HANH,
    DA_PHAT_HANH,
    DUNG_PHAT_HANH,
    CHO_XU_LY_HUY,
    HUY_HOA_DON,
    THAT_BAI,
    CHUYEN_KHOAN,
    QUET_THE,
    IMPORT,
    CONG_NO,
    juridicalOption,
    paymentMethods,
    numberRetestOption,
    resultTestOption,
    taskStatusOption,
    typeExamOption,
    checkPlagiarismOption,
    typeTaskOption,
    statusTaskOption,
    quarterOptions,
    statusOkrOption,
    typeOkrOption,
    statusOptions,
    typeExamTest,
    ExamType,
    typeNotMainExam,
    CITIME,
    PILOT_EMPLOYEE_CODES
}
